export const getPermissionsUrl = (offset: number, rows: number) => {
  return `/admin/permissions?offset=${offset}&rows=${rows}`;
};
